import { render } from "./ImportHeaders.vue?vue&type=template&id=c69401b2"
import script from "./ImportHeaders.vue?vue&type=script&lang=js"
export * from "./ImportHeaders.vue?vue&type=script&lang=js"

import "./ImportHeaders.vue?vue&type=style&index=0&id=c69401b2&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__